import React from 'react';
import { css } from 'styled-components';
import CustomMedia from 'util/custom-media-query';
import { applyStyles } from 'util/helpers';
import Colors from 'constants/colors';
import FontStyles from 'constants/font-styles';
import { NavLink } from 'react-router-dom';

const AboutContent = ({ className, content, detail }) => (
  <div className={className}>
    {content && (
      <p className="content">
        {content.map((item, i) => (
          <label key={i}>
            {item.normal ? (
              <label dangerouslySetInnerHTML={{ __html: item.normal }} />
            ) : (
              <label>
                {item.link ? (
                  <NavLink to={`${item.link[1]}`} className="link">
                    {item.link[0]}
                  </NavLink>
                ) : (
                  <label className="line">{item.line}</label>
                )}
              </label>
            )}
          </label>
        ))}
      </p>
    )}
    {detail && (
      <p className="detail">
        {detail.map((item, j) => (
          <label key={j}>
            {item.link ? (
              <NavLink
                to={`${item.link[1]}`}
                className="link"
                dangerouslySetInnerHTML={{ __html: item.link[0] }}
              />
            ) : (
              <label
                className={item.isAnnotation ? 'annotation' : ''}
                dangerouslySetInnerHTML={{ __html: item.normal }}
              />
            )}
          </label>
        ))}
      </p>
    )}
  </div>
);

const commonStyle = css`
  p {
    margin: 0;
  }

  a {
    cursor: pointer;
  }

  .content,
  .detail {
    color: ${Colors.black1};

    .link {
      text-decoration: none;
      color: ${Colors.orange1};
      border-bottom: 1px solid ${Colors.orange1};

      &:hover,
      &:active {
        color: ${Colors.orange3};
        border-bottom: 1px solid ${Colors.orange3};
        cursor: pointer;
      }
    }
  }

  .content {
    .line {
      border-bottom: 1px solid ${Colors.orange1};
    }
  }

  .annotation {
    display: block;
    padding-left: 1.25em;
    text-indent: -1.25em;
  }

  border-top: 1px solid ${Colors.gray3};
`;

const pcStyle = CustomMedia.greaterThan('umedium')`
  padding-top: 17px;
  margin: 0 24px 17px;

  .content {
    ${FontStyles.text7};
  }

  .detail {
    ${FontStyles.text10};
    margin-top: 7px;
  }
`;

const spStyle = CustomMedia.lessThan('medium')`
  padding-top: 20px;
  margin: 0 16px 19px;

  .content {
    ${FontStyles.text5};
  }

  .detail {
    ${FontStyles.text8};
    margin-top: 18px;
  }
`;

export default applyStyles(AboutContent)(commonStyle, pcStyle, spStyle);



// WEBPACK FOOTER //
// ./src/components/Faq/components/AboutContent.js